module.exports = __webpack_public_path__ + "img/status-preparing.8f056100.svg";